module.exports = __webpack_public_path__ + "072873a115f1f6e1120b863cbf2ac6bd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team.mp4
// module id = 474
// module chunks = 1